import { useSelector } from 'react-redux'
import { isMobile } from 'utils'

const useIsMobile = (includeTablet: boolean = false): boolean =>
  useSelector(
    state => isMobile(state.session.context.userAgent, includeTablet)
  )

export default useIsMobile